import { Partner } from '../partner';
import { PageRequest } from '../page-request.data';
import { Sort } from '../sort.data';
import { PartnerLightData } from '../partner-light-data';

export interface PartnerState {
  partners: Partner[];
  allPartners: PartnerLightData[];
  pageRequest: PageRequest;
  loading: boolean;
  saving: boolean;
}

export const initialPartnerState: PartnerState = {
  partners: [],
  allPartners: [],
  pageRequest: {
    page: 0,
    size: 20,
    sort: {} as Sort,
    searchText: '',
  },
  loading: true,
  saving: false,
};
